import { render, staticRenderFns } from "./NodeOnboardingHoverControls.vue?vue&type=template&id=47c37c59&"
import script from "./NodeOnboardingHoverControls.vue?vue&type=script&lang=ts&"
export * from "./NodeOnboardingHoverControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports